const STATUS_KEY = 'recruitmentTaskStatuses'
const LEGACY_BOSS_STATUS_KEY = 'bossTaskStatus'
const STATUS_EVENT = 'recruitment-task-status-change'

const channelConfig = {
  boss: { stopKey: 'bossTaskStop', commandKey: 'BtnType' },
  liepin: { stopKey: 'liepinTaskStop', commandKey: 'LPBtnType' },
  zhilian: { stopKey: 'zhilianTaskStop', commandKey: 'ZLBtnType' }
}

export function getTaskStatuses() {
  try {
    const statuses = JSON.parse(localStorage.getItem(STATUS_KEY) || '{}')
    if (!statuses.boss) {
      const legacyBossStatus = JSON.parse(localStorage.getItem(LEGACY_BOSS_STATUS_KEY) || 'null')
      if (legacyBossStatus) statuses.boss = legacyBossStatus
    }
    return statuses
  } catch (error) {
    return {}
  }
}

export function getTaskStatus(channel) {
  return getTaskStatuses()[channel] || null
}

export function startTask(channel, type) {
  const config = channelConfig[channel]
  if (!config) return null

  sessionStorage.removeItem(config.stopKey)
  const statuses = getTaskStatuses()
  const status = { channel, type, startedAt: Date.now() }
  statuses[channel] = status
  localStorage.setItem(STATUS_KEY, JSON.stringify(statuses))
  if (channel === 'boss') localStorage.setItem(LEGACY_BOSS_STATUS_KEY, JSON.stringify(status))
  window.dispatchEvent(new CustomEvent(STATUS_EVENT, { detail: statuses }))
  return status
}

export function stopTask(channel) {
  const config = channelConfig[channel]
  const statuses = getTaskStatuses()
  const status = statuses[channel]
  if (!config || !status) return null

  // 结束标记和平台命令供正在运行的自动化脚本读取。
  const stoppedAt = Date.now()
  sessionStorage.setItem(config.commandKey, '停止')
  sessionStorage.setItem(config.stopKey, JSON.stringify({ type: status.type, stoppedAt }))
  delete statuses[channel]
  localStorage.setItem(STATUS_KEY, JSON.stringify(statuses))
  if (channel === 'boss') localStorage.removeItem(LEGACY_BOSS_STATUS_KEY)
  window.dispatchEvent(new CustomEvent(STATUS_EVENT, { detail: statuses }))
  window.postMessage({ type: 'RECRUITMENT_AI_TASK_STOP', channel, task: status.type }, '*')
  return status
}

// 保留 BOSS 旧接口，避免其他已接入页面受到影响。
export const getBossTaskStatus = () => getTaskStatus('boss')
export const startBossTask = type => startTask('boss', type)
export const stopBossTask = () => stopTask('boss')
export const BOSS_TASK_STATUS_EVENT = STATUS_EVENT
export const RECRUITMENT_TASK_STATUS_EVENT = STATUS_EVENT
